import React from 'react'
export default class ButtonAction extends React.Component{
  constructor (props) {
      super (props)
      this.onClick_Handdle = this.onClick_Handdle.bind(this)
  }
  onClick_Handdle (){
    this.props.onClick_()
  }
  render () {

    return <button onClick={this.onClick_Handdle}>{this.props.actionName}</button>
  }
}



// WEBPACK FOOTER //
// ./src/components/Patient/SuperMedicalMix/ButtonAction.js